import { render, staticRenderFns } from "./TurnoverTotal.vue?vue&type=template&id=08c9ca58&"
import script from "./TurnoverTotal.vue?vue&type=script&lang=js&"
export * from "./TurnoverTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports